import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSiteConfig } from "../../context/SiteConfigContext";
import { useCart } from "../../context/CartContext";
import CartCanvas from "../canvas/CartCanvas";

function Card({ item }) {
  const { addToCart } = useCart();
  const navigate = useNavigate();

  const { config } = useSiteConfig();

  const initialPrice =
    item?.productType === "Variant"
      ? (item?.variants?.[0]?.price ?? 0)
      : (item?.price ?? 0);

  const initialMrp =
    item?.productType === "Variant"
      ? (item?.variants?.[0]?.mrp ?? 0)
      : (item?.mrp ?? 0);

  const initialDiscount =
    item?.productType === "Variant"
      ? (item?.variants?.[0]?.discount ?? 0)
      : (item?.discount ?? 0);

  const initialStock =
    item?.productType === "Variant"
      ? (item?.variants?.[0]?.stock ?? 0)
      : (item?.stock ?? 0);

  const [image, setImage] = useState(item?.thumbnail);
  const [slug, setSlug] = useState(item?.slug);
  const [title, setTitle] = useState(item?.title);
  const [shortDescription, setShortDescription] = useState(
    item?.shortDescription,
  );

  const [activePrice, setActivePrice] = useState(initialPrice);
  const [activeMrp, setActiveMrp] = useState(initialMrp);
  const [activeDiscount, setActiveDiscount] = useState(initialDiscount);
  const [activeStock, setActiveStock] = useState(initialStock);
  const [activeVariantId, setActiveVariantId] = useState(
    item?.productType === "Variant" && item?.variants?.length
      ? item?.variants[0]._id
      : null,
  );

  // Update price & image when variant changes
  useEffect(() => {
    if (item?.productType !== "Variant") return;
    const selected = item?.variants?.find((v) => v._id === activeVariantId);
    if (selected) {
      const newImg = selected.images?.[0] || item?.thumbnail;
      setImage(newImg);
      setActivePrice(selected.price);
      setActiveMrp(selected.mrp);
      setActiveDiscount(selected.discount);
      setActiveStock(selected.stock);
    }
  }, [activeVariantId, item]);

  const hasDiscount =
    activeDiscount !== null && activeDiscount > 0 && activeMrp > activePrice;

  const handleAddToCart = (e) => {
    const action = e.currentTarget.getAttribute("data-action");

    try {
      addToCart(item?._id, 1, activeVariantId || "");

      if (action === "buy-now") {
        navigate("/checkout");
      }
    } catch (err) {
      console.error("Add to cart error:", err);
    }
  };

  const isOutOfStock = activeStock <= 0;

  return (
    <>
      <div
        key={item._id}
        className="leaf-compact-card card-enter"
        style={{ transitionDelay: ".15s" }} // 0.15s delay per card
      >
        {/* 1. Image Area (Compact Height) */}
       <div className="c-image-container">
          <Link to={`/shop/${slug}`} className="custom-link-detail">
            <img src={image} alt={title} />
             
          </Link>
          <div className="c-overlay"></div>
          {/* Tag */}
          {/* <span className="c-badge">Discount 30%</span> */}
        </div>

        {/* 2. Details Area (Readable) */}
        <div className="c-info-box">
          {/* <div className="c-meta">
           
            <div className="c-rating">★★★★☆</div>
          </div> */}

          <h3 className="c-product-title">
            <Link
              to={`/shop/${slug}`}
              className="custom-link-detail  c-product-title"
            >
              {title}
            </Link>
          </h3>
          <p className="c-description">{shortDescription}</p>

          <div className="c-divider-line"></div>

          {/* Footer: Price + Unique Button */}
          <div className="c-card-footer">
            {isOutOfStock && (
              <button className="btn-leaf-action" type="button">
                Out of Stock
              </button>
            )}

            {!isOutOfStock && config?.productVisibility === "cart" && (
              <button
                type="button"
                className="btn-leaf-action"
                data-id={item?._id}
                data-price={activePrice}
                data-variant={activeVariantId || ""}
                data-quantity={1}
                data-action="cart"
                data-bs-toggle="offcanvas"
                data-bs-target="#cartDrawer"
                onClick={handleAddToCart}
              >
                Add to cart 
              </button>
            )}
            <div className="c-price-block">
              <span className="cp-current">₹ {activePrice.toFixed(2)}</span>
              <span className="cp-previous">₹ {activeMrp.toFixed(2)}</span>
            </div>

            
          </div>
           <a
            href={`https://wa.me/9017532000?text=Hi I need help for ${encodeURIComponent(item?.title)}`}
            target="_blank"
            rel="noopener noreferrer"
            className="appointment-btn mt-2"
          >
            Connect To Whatsapp
          </a>
        </div>
      </div>

      <div className="offcanvas offcanvas-end" id="cartDrawer" tabIndex="-1">
        <CartCanvas />
      </div>
    </>
  );
}

export default Card;
